<script>
    import { Chip } from "@axel669/zephyr"
</script>

Emails:
<Chip clickable>admin@site.com</Chip>
<Chip clickable ws="@color: @warning;">weirdge@site.com</Chip>
<Chip ws="@color: @primary;" fill>required@site.io</Chip>
